import { commonShortNouns } from "./common-short-fields";

export const platformAdminApplications = {
  title: "Business Entries",
  subtitle: "Manage business entry status, portal launch targets, and onboarding state.",
  summaryTotal: "Entries: {count}",
  summaryOnline: "Online: {count}",
  summaryDegraded: "Degraded: {count}",
  summaryOffline: "Offline: {count}",
  summaryUnknown: "Unknown: {count}",
  summaryPlanning: "Planned: {count}",
  summaryDraft: "Draft onboarding: {count}",
  summaryOnboarding: "Onboarding: {count}",
  summaryInvalidated: "Invalidation triggers: {count}",
  summaryWarning: "Warning entries: {count}",
  summaryCritical: "Critical entries: {count}",
  summaryRemediation: "Entries needing remediation: {count}",
  summaryRemediationCritical: "Critical remediation: {count}",
  tableTitle: "Business Entry Catalog",
  tableSubtitle: "Unified entry catalog for exam and range businesses.",
  searchPlaceholder: "Search by entry / domain / note",
  filterAll: "All {count}",
  filterOnline: "Online {count}",
  filterDegraded: "Degraded {count}",
  filterOffline: "Offline {count}",
  filterUnknown: "Unknown {count}",
  drawerTitle: "{name} · Status Detail",
  providerStatusTitle: "Platform Dependencies",
  accessControlTitle: "Identity Access State",
  invalidationTitle: "Invalidation Policy",
  remediationTitle: "Remediation",
  providerModeLabel: "Mode: {value}",
  providerPhaseLabel: "Phase: {value}",
  providerDependenciesLabel: "Dependencies: {value}",
  accessConfigured: "Configured",
  accessMissing: "Missing",
  accessRiskHealthy: "Healthy",
  accessRiskExpired: "Expired: {count}",
  accessRiskExpiringSoon: "Expiring soon: {count}",
  accessFields: {
    state: "Access state",
    applicationStatus: "Entry status",
    rule: "Matched rule",
    ruleDescription: "Rule description",
    reasons: "State reasons",
    grants: "Access grants",
    roleMappings: "Role mappings",
    activeCredentials: "Active credentials",
    credentialRisk: "Credential risk",
  },
  invalidationFields: {
    triggers: "Triggers",
    effects: "Effective outcome",
    warningDays: "Warning days",
    severity: "Severity",
  },
  remediationFields: {
    priority: "Priority",
    reasons: "Reasons",
    actions: "Recommended actions",
  },
  authConfigAction: "Login Mode",
  authConfigTitle: "{name} · Login Mode",
  authConfigTitleShort: "Login Mode",
  authConfigExamAdmin: "Admin Login Mode",
  authConfigCandidate: "Candidate Login Mode",
  authConfigEntryModes: "Entry Login Overrides",
  authConfigAddEntryMode: "Add Entry Rule",
  authConfigEntryKey: "Entry Key",
  authConfigEntryKeyPlaceholder: "For example exam_admin / candidate / user / operator",
  authConfigEntryMode: "Entry Login Mode",
  authConfigSaved: "Login mode configuration saved",
  severities: {
    normal: "Normal",
    warning: "Warning",
    critical: "Critical",
  },
  accessStates: {
    draft: "Draft",
    onboarding: "Onboarding",
    active: "Active",
    degraded: "Degraded",
    blocked: "Blocked",
    revoked: "Revoked",
  },
  undefinedAccessState: "Undefined access state",
  accessReasons: {
    missing_access_configuration: "Missing access configuration",
    missing_active_credentials: "Missing active credentials",
    credentials_expired: "Expired credentials present",
    credentials_expiring_soon: "Credentials expiring soon",
    application_status_not_active: "Application status is not active",
    all_credentials_revoked: "All credentials revoked",
  },
  undefinedAccessReason: "Undefined access reason",
  invalidationEffects: {
    none: "No invalidation",
    degraded_access: "Degraded access",
    blocked_access: "Blocked access",
    revoked_access: "Revoked access",
  },
  undefinedInvalidationEffect: "Undefined invalidation effect",
  remediationActions: {
    none: "No remediation needed",
    configure_access_grants: "Configure access grants",
    configure_role_mappings: "Configure role mappings",
    issue_active_credentials: "Issue active credentials",
    rotate_expiring_credentials: "Rotate expiring credentials",
    replace_expired_credentials: "Replace expired credentials",
    reactivate_application: "Reactivate application",
  },
  undefinedRemediationAction: "Undefined remediation action",
  fields: {
    name: "Application",
    status: "Runtime Status",
    domain: "Domain",
    endpoint: "Entry URL",
    note: "Business Note",
  },
  table: {
    app: "Application",
    domain: "Domain",
    note: "Business Note",
    status: commonShortNouns.status,
    latency: "Latency",
    actions: commonShortNouns.actions,
  },
} as const;
